import React from "react";
import { useParams } from "react-router";
import CreateNewProductContainer from "../../containers/products/CreateNewProduct";

const CreateProductsPage = () => {
  const { id } = useParams();
  return id ? (
    <CreateNewProductContainer productId={id} />
  ) : (
    <CreateNewProductContainer />
  );
};

export default CreateProductsPage;
